import React from 'react';
import './action.scss';

const InputField = ({ label, placeholder, type, value, onChange, disabled }) => (
  <div className='input-field'>
    <label>{label}</label>
    <input type={type} placeholder={placeholder} value={value} onChange={onChange} disabled={disabled} />
  </div>
);

export default InputField;
